// time-range.validator.ts

import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

// compares the time and set the time error if time from is less than time to
export function timeRangeValidator(
  controlNameFrom: string,
  controlNameTo: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;
    const timeFromControl = group.get(controlNameFrom);
    const timeToControl = group.get(controlNameTo);
    const timeFrom = timeFromControl?.value;
    const timeTo = timeToControl?.value;
    if (timeFrom && timeTo) {
      if (timeFrom > timeTo || timeFrom === timeTo) {
        timeFromControl?.setErrors({ invalidTimeRange: true });
        timeToControl?.setErrors({ invalidTimeRange: true });
        return { invalidTimeRange: true };
      } else {
        timeFromControl?.setErrors(null);
        timeToControl?.setErrors(null);
      }
    }
    return null;
  };
}
